(function(){
  'use strict';

  angular
      .module('checker.data')
      .factory('InteractionsCalculator', InteractionsCalculator);

  InteractionsCalculator.$inject = ['CheckerData'];

  function InteractionsCalculator(CheckerData) {

    var calculatedInteractions = [],
        availableInteractions = [],
        selectedDrugs = [],
        selectedComeds = [],
        trackedInteractionIds = [];

    return {
      checkForInteractions: checkForInteractions
    };

    // ////////////////////////////////////////////////////////

    // // calculate interactions for selected drugs and comeds
    function checkForInteractions(drugs, comeds, checkPrimaryInts, viewAll, lang){
      if (viewAll) {
        calculatedInteractions = [];
        selectedDrugs = drugs;
        availableInteractions = CheckerData.getInteractions();
        checkViewAllInteractions(drugs);
      } else {
        if (checkSelected(drugs, comeds)) {
          calculatedInteractions = [];
          selectedDrugs = drugs;
          selectedComeds = comeds;
          return CheckerData.fetchSelectedInteractions(drugs, comeds, lang).then(function(data) {
            availableInteractions = data;
            checkStandardInteractions(drugs, comeds);
            if (checkPrimaryInts) {
              checkCrossInteractions(drugs);
            }
            trackNewInteractions(calculatedInteractions, lang);

            return calculatedInteractions;
          })
        }
      }
      return calculatedInteractions;
    }

    function checkStandardInteractions (drugs, comeds) {
      drugs.forEach(function(drug){
        var pairsToCheck = [];

        comeds.forEach(function(comed){
          var drugPair = {};
          drugPair.covidDrugId = drug.id;
          drugPair.comedId = comed.id;
          pairsToCheck.push(drugPair);
        });

        checkDrugPairs(pairsToCheck);
      });
    }

    function checkCrossInteractions (drugs) {
      drugs.forEach(function(drug, i){
        var pairsToCheck = [];

        drugs.forEach(function(crossDrug, j){
          var drugPair = {};
          if (j > i){
            drugPair.covidDrugId = drug.id;
            drugPair.comedId = crossDrug.id;
            pairsToCheck.push(drugPair);
          }
        });
        checkDrugPairs(pairsToCheck);
      });
    }

    function checkViewAllInteractions (drugs) {
      drugs.forEach(function(drug){
        
        var interactions = _.filter(availableInteractions, function(interaction){
          return (interaction.primary_drug_id === drug.id);
        });
        if (!!interactions) {
          calculatedInteractions.push(interactions);
        }
      });
    }

    // // check for interaction hits for a passed in array of drug/comed IDs
    function checkDrugPairs (pairs) {
      pairs.forEach(function(combo){
        var interactions = _.find(availableInteractions, function(interaction){
          return (interaction.primary_drug_id === combo.covidDrugId && interaction.co_drug_id === combo.comedId);
        });
        if ( !!interactions ) {
          interactions.primary_drug_name = findDrug(interactions.primary_drug_id);
          interactions.co_drug_name = findCoMed(interactions.co_drug_id);
          interactions.co_drug_class = findCoMedClass(interactions.co_drug_id);
          interactions.primary_drug_class = findPrimaryDrugClass(interactions.primary_drug_id);
          calculatedInteractions.push(interactions);
        }
      });
    }

    // // check that at least one drug and one comed have been selected
    function checkSelected(drugs, comeds) {
      return !!(drugs.length > 1 || (drugs.length > 0 && comeds.length > 0));
    }

    // // Match drug ids to drug name
    function findDrug (drugId){
      var theDrug = _.find(selectedDrugs, function(drug){
        return (drug.id == drugId);
      });
      return (theDrug.name);
    }

    function findPrimaryDrugClass(drugId){
      var theDrug = _.find(selectedDrugs, function(drug){
        return (drug.id == drugId);
      });
      return (theDrug.drug_class_name);
    }

    // // Match co-med ids to drug name
    function findCoMed (drugId){
      var theCoMed = _.find(selectedComeds, function(coMed){
        return (coMed.id == drugId);
      });
      if ( !!theCoMed ) {
        return (theCoMed.name);
      } else {
        return (findDrug(drugId));
      }
    }

    function findCoMedClass(drugId){
      var theCoMed = _.find(selectedComeds, function(coMed){
        return (coMed.id == drugId);
      });
      if ( !!theCoMed ) {
        return (theCoMed.drug_class_name)
      }
    }

    function trackNewInteractions(interactions, lang) {
      if (window.location.href.indexOf('admin') === -1) {
        
        interactions.forEach(function(interaction) {
          
          var uniqueId = interaction.id;        

          if (trackedInteractionIds.indexOf(uniqueId) === -1) {
            mixpanel.track('Interaction', {
              'id': interaction.id,
              'co_drug_name': interaction.co_drug_mp_name || interaction.co_drug_name,
              'co_drug_class': interaction.co_dc_mp_name || interaction.co_drug_class,
              'primary_drug_name': interaction.primary_drug_mp_name || interaction.primary_drug_name,
              'primary_drug_class': interaction.primary_dc_mp_name || interaction.primary_drug_class,                
              'interaction status': interaction.interaction_status,
              'interaction colour': calculateInteractionColour(interaction),
              'language': lang
            });

            // Save to memory bank
            trackedInteractionIds.push(uniqueId);
          }
        });
      }
    }

    function calculateInteractionColour(interaction) {
      switch (interaction.interaction_status) {
        case 1:
          return 'red';
          break;
        case 2:
          return 'amber';
          break;
        case 3:
          return 'yellow';
          break;
        case 4:
          return 'green';
          break;
        case 5:
          return 'grey';
          break;
        default:
          return 'no set';
      }
    }
  }

})();
